import { TFunction } from 'i18next';
import { z } from 'zod';

const schema = (t: TFunction): z.Schema => {
  const pinLabel = t('global.PIN');
  const invalidMsg = t('validation.invalid', {
    field: pinLabel,
  });

  return z.object({
    code: z.string().min(1, invalidMsg).max(4, invalidMsg),
  });
};

export default schema;
